/** Narrowing the loaded list in the browser, as the other lists do. */

import type { ExceptionRecord, ExceptionStatus, ExceptionType, RiskLevel } from './types';

export interface ExceptionFilter {
  query: string;
  status: ExceptionStatus | 'all' | 'open';
  risk: RiskLevel | 'all';
  type: ExceptionType | 'all';
}

export const NO_FILTER: ExceptionFilter = { query: '', status: 'all', risk: 'all', type: 'all' };

/** "Open" is everything still live: not rejected, revoked or expired. */
export const OPEN_STATUSES: readonly ExceptionStatus[] = [
  'draft', 'pending_approval', 'approved', 'active', 'under_review', 'renewal_pending',
];

export function filterExceptions(
  rows: readonly ExceptionRecord[],
  f: ExceptionFilter,
  departmentName: (id: string) => string,
): ExceptionRecord[] {
  const words = f.query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  return rows.filter((r) => {
    if (f.status === 'open' ? !OPEN_STATUSES.includes(r.status) : f.status !== 'all' && r.status !== f.status) return false;
    if (f.risk !== 'all' && r.riskLevel !== f.risk) return false;
    if (f.type !== 'all' && r.exceptionType !== f.type) return false;
    if (!words.length) return true;
    const hay = [r.title, r.policyTitle, ...r.affectedDepartmentIds.map(departmentName)].join(' ').toLowerCase();
    return words.every((w) => hay.includes(w));
  });
}
